var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
import { buttonBaseStyles, getFocusStyles, getVariantStyles, getWidthStyles, sizeStyles } from './styles';
import { getResponsiveStyleObject } from "../../shared/utils/responsive/responsive";
function ButtonComponent(props, ref) {
    const { component, children, variant = 'primary', size = 'medium', color = 'blue', fullWidth = false, leftIcon, rightIcon, isSelected = false, disabled = false, type } = props, componentProps = __rest(props, ["component", "children", "variant", "size", "color", "fullWidth", "leftIcon", "rightIcon", "isSelected", "disabled", "type"]);
    const Component = component || 'button';
    const buttonProps = {};
    if (Component === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    }
    else {
        if (disabled) {
            buttonProps['aria-disabled'] = disabled;
        }
    }
    return (_jsxs(Component, Object.assign({ ref: ref, css: [
            buttonBaseStyles,
            getFocusStyles(color, variant),
            getWidthStyles(fullWidth),
            getResponsiveStyleObject(size, (size) => sizeStyles[size]),
            getVariantStyles(variant, color, isSelected), // variant styles must come after sizeStyles in order to override padding for link variant
        ], "data-disabled": disabled || undefined, tabIndex: disabled ? -1 : 0 }, buttonProps, componentProps, { children: [leftIcon ? _jsx("span", { css: { marginRight: '1rem', display: 'inline-flex' }, children: leftIcon }) : null, children, rightIcon ? _jsx("span", { css: { marginLeft: '1rem', display: 'inline-flex' }, children: rightIcon }) : null] })));
}
/**
 * A component that allows users to take actions, and make choices, with a single tap
 *
 * @example
 *<Button variant='primary'>Button text</Button>
 *
 */
export const Button = React.forwardRef(ButtonComponent);
